import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propBool, propShape } from '../../../helpers/custom-prop-types';
import { slideSearchPageHelper } from '../../../helpers/page/SlideSearch';
import HtmlLink from '../../Ui/Common/HtmlLink';
import Hover from '../../Ui/System/Hover';
const SlideSearchTopImageItem = (props) => {
    const { image: { id, image: backgroundImage, name }, isDisabled, } = props;
    const style = useMemo(() => backgroundImage ? { backgroundImage: `url('${backgroundImage}')` } : null, [backgroundImage]);
    return (_jsx("li", Object.assign({ className: 'category_list_item category_item_image_box', style: style }, { children: _jsx(Hover, { children: _jsx(HtmlLink, Object.assign({ className: clsx('category_item_image_button', 'link', isDisabled && 'disabled'), isNoLinkComponent: isDisabled ? 'span' : undefined, to: `/proffit_search/search?slideTypes=${id}` }, { children: slideSearchPageHelper.filterButtonFormat(name) })) }) })));
};
SlideSearchTopImageItem.propTypes = {
    image: propShape().isRequired,
    isDisabled: propBool().isRequired,
};
export default SlideSearchTopImageItem;
